import { Injectable } from '@angular/core';
import { FeatureType } from 'src/app/models/enums';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class EditOptions {

  constructor(
    public utilsService: UtilsService
  ) { }

  editElement(map: google.maps.Map, type: FeatureType, id: any, valueToChange: string, value: any) {
    const feature = this.utilsService.findFeatureByPropertyId(map.data, id, type) as any;
    if (feature) {
      switch(valueToChange) {
        case 'lat':
        case 'lng': {
          const newCoords = {
            lat: valueToChange === 'lat' ? value : feature.getGeometry().elements.lat(),
            lng: valueToChange === 'lng' ? value : feature.getGeometry().elements.lng()
          };
          feature.setGeometry(new google.maps.LatLng(newCoords.lat, newCoords.lng));
          this.updateConnectedSegmentToStop(map, id, newCoords);
          break;
        }
        case 'time':
          const seconds = this.utilsService.convertMinutesAndSecondsToSeconds(value);
          feature.setProperty('weight', seconds);
          break;
        case 'alternatives':
          if (Array.isArray(value)) {
            feature.setProperty(valueToChange, value);
          } else if (value === null) {
            feature.removeProperty(valueToChange);
          }
          break;
        default: {
          const nestedStopProperty = valueToChange.match(/^(merge|start|end)\.properties\.(\w+)$/);
          if (nestedStopProperty) {
            const [, nestedStop, property] = nestedStopProperty;
            feature.setProperty(nestedStop, {
              ...feature.getProperty(nestedStop),
              properties: { ...feature.getProperty(nestedStop)?.properties, [property]: value }
            });
          } else {
            feature.setProperty(valueToChange, value);
          }
        }
      }
    }
    return feature;
  }

  moveStop(map: google.maps.Map, id: any, coordinates: {lat: number, lng: number}, type: FeatureType = FeatureType.STOP) {
    const feature = this.utilsService.findFeatureByPropertyId(map.data, id, type);
    if (feature) {
      feature.setGeometry(new google.maps.LatLng(coordinates.lat, coordinates.lng));
      this.updateConnectedSegmentToStop(map, id, coordinates);
    }
  }

  updateConnectedSegmentToStop(map: google.maps.Map, stopId: any, newCoords: {lat: number, lng: number}) {
    map.data.forEach((feature: any) => {
      if (feature.getProperty('type') === FeatureType.SEGMENT) {
        let coordIndex = -1;
        if (feature.getProperty('start')?.properties.id === stopId) coordIndex = 0;
        else if (feature.getProperty('end')?.properties.id === stopId) coordIndex = feature.getGeometry().getArray().length - 1;
        if (coordIndex !== -1) {
          let segmentCoords = feature.getGeometry().getArray().map((coord: any) => ({lat: coord.lat(), lng: coord.lng()}));
          segmentCoords[coordIndex] = newCoords;
          feature.setGeometry(new google.maps.Data.LineString(segmentCoords.map((c: any) => new google.maps.LatLng(c.lat, c.lng))));
        }
      }
    });
  }
  
  syncPolylineToSegment(map: google.maps.Map, polyline: google.maps.Polyline, segmentId: number): google.maps.MapsEventListener[] {
    const path = polyline.getPath();
    const sync = () => {
      const coords = path.getArray().map((ll) => new google.maps.LatLng(ll.lat(), ll.lng()));
      const feature = this.utilsService.findFeatureByPropertyId(map.data, segmentId, FeatureType.SEGMENT);
      if (feature) feature.setGeometry(new google.maps.Data.LineString(coords));
    };
    return [
      path.addListener('set_at', sync),
      path.addListener('insert_at', sync),
      path.addListener('remove_at', sync),
    ];
  }
  
}
